import React from 'react'
import { withRouter } from 'react-router-dom'

import styles from './styles.scss'

const PageNotFound = ( { history } ) => (
  <section className={styles['wrapper-page-not-found']}>
    <div
      className={styles['wrapper-page-not-found__bubble']}
    >
      <div
        className={styles['wrapper-page-not-found__message']}
      />
    </div>
    <div
      className={styles['wrapper-page-not-found__person']}
    >
      <button
        onClick={() => history.push( '/dashboard' )}
      >
        BACK
      </button>
    </div>
  </section>
)

export default withRouter( PageNotFound )


// WEBPACK FOOTER //
// ./src/pages/PageNotFound/index.js